let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jrM9n")).then(() => parcelRequire('7ykDM'));